import React from 'react'
import PropTypes from 'prop-types'
import { AUTH_REDIRECT_PATH } from '@maui-mf/common-auth'
import { AuthProvider } from '@maui-mf/common-react'
import { ExperimentsProvider } from '@maui-mf/experiments'
import { MauiMfSplitFactory } from '@maui-mf/splitio-react'
import { MauiQueryClientProvider } from '@maui/react-query'
import env from '@maui-mf/env'

const defaultAuth = {
  clientId: env.MAUI_IDP_CLIENT_ID,
  host: env.MAUI_IDP_HOST,
  redirectUri: new URL(AUTH_REDIRECT_PATH, env.MAUI_HOST).toString(),
}

export const MauiProvider = ({
  auth,
  children,
  queryClient,
}) => {
  return (
    <AuthProvider {...defaultAuth} {...auth}>
      <MauiQueryClientProvider {...queryClient}>
        <MauiMfSplitFactory>
          <ExperimentsProvider>
            {children}
          </ExperimentsProvider>
        </MauiMfSplitFactory>
      </MauiQueryClientProvider>
    </AuthProvider>
  )
}

MauiProvider.defaultProps = {
  queryClient: {},
  auth: {},
}

MauiProvider.propTypes = {
  auth: PropTypes.object,
  queryClient: PropTypes.object,
  children: PropTypes.node,
}
